import React from 'react';

import './styles.css';

import eventServices from '../../../../services/academy/eventServices';

import { FaTrash } from 'react-icons/fa';

export default function CalendarCard(props) {
  async function deleteEvent() {
    // eslint-disable-next-line no-restricted-globals
    if (confirm(`Remover evento?`)) {
      const response = await eventServices.deleteEvent(props.id);
      if (response.status === 204) {
        props.onDelete();
      } else
        alert("Erro ao apagar evento, tente novamente!");
    }
  }

  function eventStatus() {
    // if (!Array.isArray(date)) return ' invalid';

    return '';

    // let dateTimeNow = new Date().toISOString().slice(0, 19).split('T');
    // let d = new Date(1542471749270);
    // let d2 = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);
    // console.log(d2, dateTimeNow);
    // let a = {
    //   date: props.date,
    //   startTime: props.startTime,
    //   endTime: props.endTime,
    // }, b = {
    //   date: dateTimeNow[0],
    //   time: dateTimeNow[1],
    // };
    // console.log('COMPARA', a, b);
    // if (props.date < dateTimeNow[0] || (props.date === dateTimeNow[0] && props.endTime < dateTimeNow[1])) return ' past';
    // else if (props.date === dateTimeNow[0] && props.startTime <= dateTimeNow[1] && props.endTime >= dateTimeNow[1]) return ' now';
    // else return '';
  }

  return (
    <li className={'calendar-card' + eventStatus()}>
      <h6
        className='tittle'
      >{props.tittle ? props.tittle : 'Sem título'}</h6>
      {
        props.description ?
          <p><b>Descrição: </b>{props.description}</p>
          : []
      }

      <p className="time">
        {
          props.startTime && props.endTime ?
            `Das ${props.startTime.slice(0, 5)} às ${props.endTime.slice(0, 5)}`
            : 'Datas inválidas'
        }
      </p>

      {
        props.class || props.block || eventStatus() === ' now' ?
          <div className='tags'>
            {
              props.class ?
                <p className="tag class-tag"><b>Turma: </b>{props.class.nome}</p>
                : []
            }
            {
              props.block ?
                <p className="tag block-tag">Horário bloqueado</p>
                : []
            }
            {
              eventStatus() === ' now' ?
                <p className='tag'>Acontecendo agora</p>
                : []
            }
          </div>
          : []
      }

      {
        props.canDelete && props.coachMode !== true ?
          <button className='delete' onClick={deleteEvent}><FaTrash /></button>
          : []
      }
    </li>
  )
}